import { render, staticRenderFns } from "./shipment-rules-modal-assay-relationships.vue?vue&type=template&id=8f3e2e34&scoped=true&"
import script from "./shipment-rules-modal-assay-relationships.ts?vue&type=script&lang=ts&"
export * from "./shipment-rules-modal-assay-relationships.ts?vue&type=script&lang=ts&"
import style0 from "./shipment-rules-modal-assay-relationships.scss?vue&type=style&index=0&id=8f3e2e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3e2e34",
  null
  
)

export default component.exports